import { render } from "./IndicatorsDetail.vue?vue&type=template&id=74d91d10&scoped=true&ts=true"
import script from "./IndicatorsDetail.vue?vue&type=script&lang=ts"
export * from "./IndicatorsDetail.vue?vue&type=script&lang=ts"

import "./IndicatorsDetail.vue?vue&type=style&index=0&id=74d91d10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d91d10"]])

export default __exports__